import styles from './index.module.css'
import classnames from 'classnames'
import { Notification } from '@appkit4/react-components/notification'

const Circle = ({ timer }) => {
    const style = {
        '--pop-alert-timer': `${timer}ms`
    }
    return (
        <svg className={styles.timer} height="16" width="16">
            <circle className={styles.timerIcon} style={style} cx="8" cy="8" r="4"></circle>
        </svg>
    )
}

const Message = ({ message, timer }) => {
    return (
        <div className={styles.container}>
            {message}
            {!!timer && <Circle timer={timer} />}
        </div>
    )
}

export const View = ({ message, timer, onClose, className, ...props }) => {
    return (
        <Notification
            className={classnames(styles.default, className)}
            message={<Message message={message} timer={timer} />}
            {...props}
            closeable={false}
        />
    )
}
